export enum PpSetupGroupNames {
  POST_PROCESSING_SETTINGS = 'Post Processing Settings',
}
